import { render, staticRenderFns } from "./ForumCreateEditModal.vue?vue&type=template&id=2b6f0360&scoped=true"
import script from "./ForumCreateEditModal.vue?vue&type=script&lang=js"
export * from "./ForumCreateEditModal.vue?vue&type=script&lang=js"
import style0 from "./ForumCreateEditModal.vue?vue&type=style&index=0&id=2b6f0360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6f0360",
  null
  
)

export default component.exports